import { Component, OnInit, ElementRef, Renderer2, ViewChild, HostListener } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from "@angular/router";
import { debounceTime, distinctUntilChanged, Observable, of, Subscription, switchMap } from "rxjs";
import { API_ROUTES } from "src/app/core/_constants/api-route.constant";
import { ApiServicesService } from "src/app/services/apiServices/api-services.service";
import { CommonService } from "src/app/services/common.service";
import { SearchService } from "src/app/services/search.service";
import { LocalStorageProvider } from "src/app/services/storage/storage.service";
import { RouteConstant } from "src/app/core/_constants/route.constant";
import { DataService } from "src/app/services/data.service";
import { LogoutComponent } from "src/app/shared/dialogs/logout/logout.component";
import { FilterProductComponent } from "src/app/shared/dialogs/filter-product/filter-product.component";
import { EditEnquiryComponent } from "src/app/modules/pages/profile/edit-enquiry/edit-enquiry.component";
import { ToastrService } from "ngx-toastr";
import { LoginComponent } from "src/app/auth/login/login.component";
import { BreakpointObserver } from "@angular/cdk/layout";


declare var bootstrap: any;
interface Product {
  country_origin: string;
  name: string;
  image: string;
  category: string;
  origin: string;

}
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  dialog: any;
  companyProfile: any;
  subCategoryData: any[] = []; // To hold subcategories and their products
  Searchresults: any[] = []; // To hold subcategories and their products
  filterData: any;
  page: number = 1; // Default value
  Size: number = 10; // Default value
  sortby: any // Default value
  productslist: Product[] = []; // Array of products typed with the Product interface
  scrolledBottom: boolean;
  recentSearches: any[] = [];
  show: boolean;
  data: any;
  selectedLocation: any = null;
  limitedProducts: any;
  apiData: any; // To hold the full API response
  categories: any[];
  selectedSubCategory: any;
  dropdownMenu: ElementRef<any>;
  Searchresult: any;
  domUrls: string;
  //industry: any;
  subCategoryProducts: any[] = [];
  allProducts: any[] = [];
  selectedSubCategoryId: any;
  selectedSubCategory1: any;

  isMobileView: boolean = false;


  industry: any[] = [];
  AllSubCategory1: any[] = [];
  AllSubCategory2: any[] = [];

  selectedParams: any = {
    industryId: null,
    subCategory1Id: null,
    subCategory2Id: null,
  };

  logout() {
    {
      const screenWidth = window.innerWidth;
      let isSmallScreen = false;
      if (screenWidth <= 800) {
        isSmallScreen = true;
      }
      const dialogRef = this.dialogRef.open(LogoutComponent, {
        maxHeight: '100vh',
        width: isSmallScreen ? '70%' : '40%',
        data: {
          img: '../assets/images/new_img/logout.svg',
          heading: 'Are you sure you want to logout?',
          report: 'Yes, Logout',
          cancel: 'Cancel',
        }
      })
    }

  }


  enquiry() {
    const screenWidth = window.innerWidth;
    let isSmallScreen = false;
    if (screenWidth <= 1440) {
      isSmallScreen = true;
    }
    let token = localStorage.getItem('stoken');
    if (token) {
      const dialogRef = this.dialogRef.open(EditEnquiryComponent, {
        maxHeight: '100vh',
        width: isSmallScreen ? '1000px' : '1000px',
        maxWidth: isSmallScreen ? '95vw' : '80vw', 
        // data: {
        //   company_name: this.company_name,
        //   phone_no: this.phone_no,
        // }
      });
    }

    else {
      this.toastr.error('Need to login first');
      this.Login();
      // this.router.navigate(['/login']);
    }
  }

  Login() {
    const screenWidth = window.innerWidth;
    let isSmallScreen = true;
    if (screenWidth <= 1440) {
      isSmallScreen = true;
    }
    const dialogRef = this.dialogRef.open(LoginComponent, {
      maxHeight: '100vh',
      width: isSmallScreen ? '100%' : '70%',
      maxWidth: isSmallScreen ? '95vw' : '80vw',  
    })

  }
  showHeader: boolean = true;
  showSearch: boolean = true;
  showNotification: boolean = true;
  isShow = false;
  obs: Subscription;
  RouteConstant: any = RouteConstant;
  homeScreen: any = "/" + RouteConstant.mainhome;
  marketPlace: any =
    "/" + RouteConstant.main + "/" + RouteConstant.marketPlaceList;
  viewall: any = "/" + RouteConstant.main + "/" + RouteConstant.marketPlaceList + "/" + RouteConstant.popularProducts;
  // viewsingleproduct: any = "/" + RouteConstant.main + "/" + RouteConstant.marketPlaceList + "/" + RouteConstant.marketplaceProductDetail;
  moreProfile: any = "/" + RouteConstant.main + "/" + RouteConstant.moreProfile;
  profile: any = "/" + RouteConstant.main + "/" + RouteConstant.profile;
  business: any = "/" + RouteConstant.business;
  currentProfile: any;
  showprofile: boolean = true;
  subscription: Subscription;
  showlogo: boolean = true;
  showChat: boolean = true;
  searchControl = new FormControl();
  guestUser: string | null;
  notificationBadgeCount: any;
  isModalVisible: boolean = false;

  // viewSingleProduct(productId: string, category: string, dropdownMenu: HTMLElement) {
  //   const dropdownInstance = new bootstrap.Dropdown(dropdownMenu);
  //   dropdownInstance.hide();
  //   let token = localStorage.getItem('stoken');
  //   if (token) {
  //     if (category == 'Machine') {
  //       this.router.navigate([RouteConstant.machine], { queryParams: { productId: productId } });
  //     } else if (category == 'Services') {
  //       this.router.navigate([RouteConstant.service], { queryParams: { productId: productId } });
  //     } else if (category == 'Tools') {
  //       this.router.navigate([RouteConstant.tools], { queryParams: { productId: productId } });
  //     } else if (category == 'Raw Material') {
  //       this.router.navigate([RouteConstant.rawmaterials], { queryParams: { productId: productId } });
  //     }
  //   }
  //   else {
  //     this.toastr.error('Need to login first');
  //     this.Login();
  //   }
  // }

  selectedCategory = 'Metal';
  selectedFilter = 'All';
  filteredProducts: Product[] = [];
  @ViewChild('searchInput') searchInput: ElementRef;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private commonService: CommonService,
    private storageService: LocalStorageProvider,
    private searchService: SearchService,
    private service: ApiServicesService,
    public dialogRef: MatDialog,
    private dataService: DataService,
    private renderer: Renderer2,
    private el: ElementRef, private toastr: ToastrService,
    private route: ActivatedRoute,
  ) {
    this.commonService.getData().subscribe((data) => {
      this.isCompanyInterest = data;
    });

    this.domUrls = this.service.getBaseUrl();

    this.renderer.listen('window', 'click', (e: Event) => {
      if (
        e.target !== this.searchInput?.nativeElement &&

        e.target !== this.dropdownList?.nativeElement &&
        !this.dropdownList?.nativeElement.contains(e.target)
      ) {

        // console.log("hjbehfyezy")
        this.filteredResults2 = [];
        this.recentSearches = [];
      }
    });

  }
  showdropdown() {
    this.isShow = !this.isShow;
  }

  isCompanyInterest: any;
  prod_data: any
  resultNotification: any;
  Notification: any;
  NotificationAll: any;
  allNotifications: any[] = [];  // Stores the entire notification list
  currentPage = 1;
  pageSize = 10;
  isLoading = false;
  hasMoreData = true;

  searchControls = new FormControl('');
  isCompanyInterests = true; // Example flag, set based on your logic
  filteredResults2: any[] = [];
  showResults2 = false;
  searchTerm: string;


  onDropdownMenuClick(event: Event): void {
    event.stopPropagation();
  }


  searchPlaceholder: string = 'Search by Category, Manufacturer, Model...';
  headerMargin: any = '';
  ngOnInit(): void {
    this.service.pdpLoginStatus$.subscribe(status => {
          if (status) {
            localStorage.setItem("guestUser", "");
            this.guestUser = localStorage.getItem("guestUser");
            this.getProfile();
            this.getNotification();
          }
    });
    this.breakpointObserver.observe(['(max-width: 492px)']).subscribe(result =>
      this.searchPlaceholder = result.matches ? 'Search...' : 'Search by Category, Manufacturer, Model...'
    );

    window.scrollTo(0, 0);
    this.checkScreenSize();
    window.addEventListener('resize', () => {
      this.checkScreenSize();
    });

    this.getProfile();
    // this.getcurrentlocation();
    this.selectedFilter = 'All';
    this.getCategories();
    this.getNotification();
    this.page = 1; // Set default page to 1
    this.Size = 10; // Set default size to 10
    this.sortby = 10; // Set a default sortby value


    this.dataService.searchValue$.subscribe(val => {
      if (val !== '') {
        this.searchControl.patchValue(val);
      }
    })
    let token = localStorage.getItem("stoken");
    if (!token) {
      localStorage.setItem("guestUser", "yes");
    } else {
      localStorage.removeItem("guestUser");
    }
    this.isCompanyInterest = localStorage.getItem("companyInterest");
    if (this.isCompanyInterest == false)
      this.isCompanyInterest = false;

    this.guestUser = localStorage.getItem("guestUser");

    this.searchService.currentProfile.subscribe(
      (text) => (this.currentProfile = text)
    );

    if (this.currentProfile == "other") {
      this.showHeader = true;
    } else {
      this.showHeader = true;
    }
    this.searchControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((val) => {
        this.dataService.setSearchValue(val);
        if (val.trim() !== "") this.searchService.changeSearch(val);
        else if (!val) {
          this.searchService.changeSearch("");
        }
      });


    // Listen to search input changes
    this.searchControls.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((searchTerm: string | null) => this.filterData2(searchTerm || ''))
    ).subscribe((results: string[]) => {
      this.filteredResults2 = results;
    });

    this.route.queryParams.subscribe(params => {
      this.selectedLocation = params['location'] || null;
    });

  }


  checkScreenSize() {
    this.isMobileView = window.innerWidth < 767;
  }


  headerPic: any;
  isUserLoggedIn() {
    const token = localStorage.getItem('stoken');
    if (token) {
      return true;
    } else {
      return false;
    }
  }

  getProfile() {
    if (!this.isUserLoggedIn()) {
      // console.log('User is not logged in');
      return;
    }
    const apiEndpoint = API_ROUTES.More.moreDetails;
    if (!apiEndpoint) {
      // console.log('API endpoint is undefined');
      return;
    }
    this.service.get({}, apiEndpoint).subscribe({
      next: (response) => {

        this.headerPic = response?.result[0]?.UserAuths[0]?.profile_pic;
        this.service.company_name = response?.result[0]?.UserAuths[0]?.company_name;
        this.service.phone_no = response?.result[0]?.phone_no;
        this.service.userauth_id = response?.result[0]?.UserAuths[0]?.auth_id;
        // console.log('API response:', response?.result[0]?.UserAuths[0]);
      },
      error: (err) => {
        console.error('Error fetching profile details:', err);
      }
    });
  }


  currLat: number | null = null;
  currLog: number | null = null;
  currentlocation: any;

  getcurrentlocation(): void {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.currLat = position.coords.latitude;
          this.currLog = position.coords.longitude;

          this.getcurrentlocationUser();
        },
        (error) => {
          console?.log('Error getting location:', error);
        },
        {
          enableHighAccuracy: true, // Request accurate location data
          timeout: 10000,          // Timeout in milliseconds
          maximumAge: 0,           // Disable caching
        }
      );
    } else {
      console.warn('Geolocation is not supported by this browser.');
    }
  }

  // Make API call with current location
  getcurrentlocationUser(): void {
    // Ensure latitude and longitude are defined
    if (this.currLat === null || this.currLog === null) {
      console.error('Current latitude or longitude is not defined.');
      return;
    }

    const params: any = {
      latitude: this.currLat,
      longitude: this.currLog,
    };

    this.service.get(params, `${API_ROUTES.getlocation}`).subscribe({
      next: (res) => {

        this.currentlocation = res;
      },
      error: (err) => {
        console.error('Error fetching location data:', err);
      },
    });
  }

  totalCount = 0;


  // getNotification() {
  //   if (!this.isUserLoggedIn()) {
  //     return; 
  //   }
  //   if (!this.hasMoreData) return; 
  //   this.isLoading = true;
  //   const params = {
  //     pageNo: this.currentPage,
  //     size: this.pageSize
  //   };

  //   const apiEndpoint = API_ROUTES.Account.getNotification;
  //   if (!apiEndpoint) return; 

  //   this.service.get(params, apiEndpoint).subscribe({
  //     next: (response) => {
  //       if (response && response.result) {
  //         this.resultNotification = Array.isArray(response.result)
  //           ? response.result
  //           : [response.result];
  //         this.Notification = this.resultNotification;
  //         this.allNotifications = [...this.allNotifications, ...this.resultNotification[0].notifications];
  //         this.totalCount = response.result?.totalCount || 0;
  //         this.NotificationAll = [...this.allNotifications];
  //         if (this.allNotifications.length < this.totalCount) {
  //           this.currentPage++; 
  //         }else {
  //           this.hasMoreData = false; 
  //         }
  //         this.isLoading = false;
  //       } 
  //       else {
  //         this.hasMoreData = false;
  //         console.warn('No notifications found in the response:', response);
  //       }

  //     },
  //     error: (err) => {
  //       console.error('Error fetching notifications:', err);
  //     }
  //   });
  // }
  // onScroll(event: any): void {
  //   event.preventDefault();
  //   const { scrollTop, scrollHeight, clientHeight } = event.target;
  //   if (scrollTop + clientHeight >= scrollHeight - 10) {
  //     this.getNotification();
  //   }
  // }
  getNotification(): void {
    if (!this.isUserLoggedIn()) {
      return;
    }

    if (!this.hasMoreData || this.isLoading) return; // Prevent multiple calls while loading

    this.isLoading = true; // Set isLoading to true to prevent further calls

    const params = {
      pageNo: this.currentPage,
      size: this.pageSize
    };

    const apiEndpoint = API_ROUTES.Account.getNotification;
    if (!apiEndpoint) return;

    this.service.get(params, apiEndpoint)?.subscribe({
      next: (response) => {
        if (response && response.result) {
          this.resultNotification = Array.isArray(response.result) ? response.result : [response.result];
          this.Notification = this.resultNotification;
          const newNotifications = Array.isArray(this.resultNotification[0]?.notifications)
            ? this.resultNotification[0]?.notifications
            : [];

          this.allNotifications = [...this.allNotifications, ...newNotifications];

          this.totalCount = response.result?.totalCount || 0;
          this.NotificationAll = [...this.allNotifications];

          if (this.allNotifications.length < this.totalCount) {
            this.currentPage++;
          } else {
            this.hasMoreData = false; // No more data to fetch
          }

          // Set isLoading to false once the API call is complete
          this.isLoading = false;
        } else {
          this.hasMoreData = false; // No more data available
          console.warn('No notifications found in the response:', response);
          this.isLoading = false;
        }
      },
      error: (err) => {
        console.error('Error fetching notifications:', err);
        this.isLoading = false;
      }
    });
  }

  onScroll(event: any): void {
    event.preventDefault();
    const { scrollTop, scrollHeight, clientHeight } = event.target;

    if (scrollTop + clientHeight >= scrollHeight - 10) {
      this.getNotification();
    }
  }

  markAsRead(notification: any, index: number) {
    if (!notification || !notification.id) return;
    const apiEndpoint = API_ROUTES.Account.markNotificationRead;
    const params = {
      id: notification.id,
      status: 1
    };

    this.service.post(params, apiEndpoint, {}).subscribe({
      next: () => {
        console.log(`Notification with ID ${notification.id} marked as read`);
        this.hasMoreData = true;
        this.isLoading = false;

        // Reset current page and notification list
        this.currentPage = 1;
        this.allNotifications = []; // Clear the list to reload
        this.getNotification();
      },
      error: (err) => {
        console.error('Error marking notification as read:', err);
      }
    });
  }


  locations = [
    { name: 'Delhi', icon: 'assets/icons/delhi.png' },
    { name: 'Bangalore', icon: 'assets/icons/banaglore.png' },
    { name: 'Mumbai', icon: 'assets/icons/mumbai.png' },
    { name: 'Chennai', icon: 'assets/icons/chennai.png' },
    { name: 'Hyderabad', icon: 'assets/icons/hyderabad.png' },
    { name: 'Pune', icon: 'assets/icons/pune.png' },
    { name: 'Kolkata', icon: 'assets/icons/kolkatta.png' },
    { name: 'Ahmedabad', icon: 'assets/icons/ahmedabad.png' },
  ];

  showLocationBox = false;


  toggleLocationBox(): void {
    this.showLocationBox = !this.showLocationBox;
  }


  selectLocation(location: any): void {
    this.selectedLocation = location;
    this.showLocationBox = false;

  }

  stateVaule(location: any, productTitle: string | null): void {
    this.selectedLocation = location;
    this.showLocationBox = false;
    this.filteredResults2 = [];
    this.showResults2 = false;

    // Construct query parameters
    const queryParams = {
      location: location,
      title: productTitle,
    };

    // Navigate with query parameters    

    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate(['/main/search'], { queryParams }).then(() => {
        // console.log("I am firing after navigation")
        // Ensure the location persists in the service
        this.selectedLocation = location;
      });
    });
  }


  SearchProduct() {
    // debugger;
    // if (!this.isUserLoggedIn()) {
    //   // console.log('User not logged in.');
    //   return;
    // }

    const apiEndpoint = (this.isUserLoggedIn() === true)  ? API_ROUTES.SearchProduct : API_ROUTES.SearchProductWIthoutLogin;
    if (!apiEndpoint) {
      console.error('API endpoint is undefined.');
      return;
    }
    const searchTermString = this.searchControls.value?.trim(); // Get value from the form control
    if (!searchTermString) {
      console.error('Search term is empty.');
      return;
    }
    // Define payload
    const payload = {
      title: searchTermString,
      location: this.selectedLocation?.name,
    };

    // Call API
    this.service.post(payload, apiEndpoint, {}).subscribe({
      next: (response) => {
        // console.log("response>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",response)
        if (response?.data?.products) {
          this.Searchresults = response.data.products; // Ensure global assignment
          // console.log('Search Results:', this.Searchresults);
        } else {
          console.warn('No products found in the response.');
          this.Searchresults = [];
        }
      },
      error: (error) => {
        console.error('Error fetching search results:', error);
      },
    });
  }
  // filterData2(searchTerm: any): Observable<string[]> {
  //   if (!searchTerm) {

  //     return of([]);
  //   }

  //   // Ensure `searchTerm` is treated as a string
  //   const searchTermString = String(searchTerm).toLowerCase();

  //   if (!this.Searchresults || !Array.isArray(this.Searchresults)) {
  //     console.error('Search results are not initialized or invalid.');
  //     return of([]);
  //   }
  //   // Searchresults
  //   const filteredResults2 = this.Searchresults.filter((item: any) => {
  //     const itemTitle = item?.Category3?.title || ''; // Adjust field name based on your product object structure
  //     return itemTitle.toLowerCase().includes(searchTermString);
  //   });

  //   return of(filteredResults2);
  // }


  // onSearch(searchTerm: any): void {
  //   const inputValue = (searchTerm.target as HTMLInputElement).value;
  //   if (inputValue && this.showLocationBox) {
  //     this.showLocationBox = false;
  //   }
  //   this.SearchProduct(); // Load search results if not already loaded
  //   this.filterData2(searchTerm).subscribe((filteredResults) => {
  //     this.filteredResults2 = filteredResults;

  //   });
  // }
  onSearch(searchTerm: any): void {
    const inputValue = (searchTerm.target as HTMLInputElement).value;
    if (inputValue && this.showLocationBox) {
      this.showLocationBox = false;
    }
    this.SearchProduct(); // Load search results if not already loaded
    this.filterData2(inputValue).subscribe((filteredResults) => {
      this.filteredResults2 = filteredResults;
    });
  }


  fetchRecentSearches(): void {
    // console.log("I am firing from fetchRecentSearches")
    const apiEndpoint = API_ROUTES.SearchRecentProduct;

    this.service.get({}, apiEndpoint).subscribe(
      (response: any) => {
        if (response.success) {
          // console.log("fetchRecentSearches_______________________", response)
          this.recentSearches = response.data.products || [];
        } else {
          console.error('Failed to fetch recent searches:', response.message);
        }
      },
      (error) => {
        console.error('Error fetching recent searches:', error);
      }
    );
  }
  autoCloseForDropdownCars(event: any) {
    var target = event.target;
    if (!target.closest(".DropdownCars")) {
      // do whatever you want here 
      this.showLocationBox = false;
    }
  }
  @ViewChild('dropdownList') dropdownList: ElementRef;

  //  autoCloseForDropdownCars1(event: any,dropdownList: HTMLElement) {
  //   console.log("DropdownCars1")
  //   var target = event.target;
  //   // if (!target.closest(".DropdownCars1")) { 
  //     if (!dropdownList.contains(event.target as Node)) {
  //       console.log("DropdownCars1 inside")

  //       // do whatever you want here 
  //        this.showLocationBox = false;
  //        this.filteredResults2 = []; // Clear the predictive search results
  //       //  this.recentSearches = []
  //   }
  //  }
  // @HostListener('document:click', ['$event'])
  // onDocumentClick(event: MouseEvent) {
  //   const clickedInside = this.dropdownList?.nativeElement.contains(event.target);
  //   const clickedInsideInput = this.searchInput?.nativeElement.contains(event.target);

  //   // Prevent clearing if the click is inside the search input or dropdown
  //   if (!clickedInside && !clickedInsideInput && !this.hasFocus) {
  //     this.filteredResults2 = [];
  //     this.recentSearches = [];
  //   }
  // }

  // Show results when input is focused
  onFocus(): void {
    this.showResults2 = true;
  }

  // Hide results when input loses focus
  onBlur(): void {
    setTimeout(() => {
      this.showResults2 = false;
    }, 200); // Small delay to allow click events on results
  }

  // Handle result selection
  onSelectResult(result: string): void {
    this.searchControls.setValue(result);
    this.showResults2 = false; // Hide the results
    // console.log('Selected:', result);
  }


  // navigateToProductListing(industry: any, dropdownMenu: HTMLElement): void {
  //   const dropdownInstance = new bootstrap.Dropdown(dropdownMenu);
  //   dropdownInstance.hide();
  //   this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
  //     this.router.navigate(['/main/product-listing'], { state: { id: industry?.id, name: industry?.industry_name } });
  //   })
  // }

  getCategories() {
    this.service.get({ sortType: 'recent' }, API_ROUTES.Account.getIndustry).
      subscribe(
        (res) => {
          if (res.success && res.result) {
            this.categories = res.result;
            // console.log(this.categories);
            if (this.categories.length) {
              this.selectedCategory = this.categories[0].industry_name;
              this.selectedFilter = 'All'; // Default to 'All'
            }

          }
        },
        (error) => {
          console.error("API call failed:", error);
        }
      );
  }
  // get subcategory
  getAllSubCategory(industryId: string) {
    this.selectedSubCategory = industryId;
    // console.log('00000000000000000000', this.selectedSubCategory);
    this.service.post({ industry_id: industryId }, API_ROUTES.Account.getIndustriesByCategorys, '').subscribe(
      (response) => {
        if (response?.result?.rows && response.result.rows.length > 0) {
          this.AllSubCategory1 = response.result.rows;
        } else {
          console.warn('No subcategories found for the selected industry.');
          this.AllSubCategory1 = [];
        }
      },
      (error) => {
        console.error('Error occurred while fetching subcategories:', error);
        this.AllSubCategory1 = [];
        // this.loader.stop(); // Ensure the loader stops in case of an error
      }
    );
  }




  selectCategory2(subCategory1Id: string,) {
    this.service.post({ category1_id: subCategory1Id }, API_ROUTES.Account.getCatByCategory1, '').subscribe(
      (response) => {
        if (response?.result?.rows && response.result.rows.length > 0) {
          this.AllSubCategory2 = response.result.rows;
        } else {
          console.warn('No subcategories found for the selected industry.');
          this.AllSubCategory2 = []; // Reset the array if no subcategories are found
        }
      },
      (error) => {
        console.error('Error occurred while fetching subcategories:', error);
        this.AllSubCategory2 = [];
        //  this.loader.stop(); 
      }
    );
  }


  // Handle SubCategory1 selection
  selectSubCategory1(subCategory1: any) {
    this.selectedParams.subCategory1Id = subCategory1.id;
    this.selectedParams.subCategory2Id = null;  // Reset SubCategory2
    // console.log('Selected SubCategory1:', this.selectedParams);
    this.selectCategory2(subCategory1.id);
  }

  // Handle SubCategory2 selection
  selectSubCategory2(subCategory2: any, dropdownMenu: HTMLElement) {
    const dropdownInstance = new bootstrap.Dropdown(dropdownMenu);
    dropdownInstance.hide();
    this.selectedParams.subCategory2Id = subCategory2.id;
    this.navigateToProductListing(subCategory2.id);
  }

  navigateMobile(category: any,) {
    this.selectedParams.industryId = category?.id
    this.navigateToProductListing(category?.id);
  }


  navigateToProductListing(items: string): void {
    const industryId = this.selectedParams.industryId;
    const subCategory1Id = this.selectedParams.subCategory1Id;
    const subCategory2Id = this.selectedParams.subCategory2Id;
    //dropdownInstance.hide();
    // Navigate and pass selectedParams as query parameters
    // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    //       this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    //   this.router.navigate(['/main/product-listing'], { state: { id: industry?.id, name: industry?.industry_name } });
    // })
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/main/product-listing',], {
        queryParams: {
          industryId,
          subCategory1Id,
          subCategory2Id
        }
      });
    })


    //  dropdownInstance.hide();
    // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    //   this.router.navigate(['/main/product-listing'], { state: { id: industry?.id, name: industry?.industry_name } });
    // })
  }

  selectCategory(industry: any) {
    this.selectedParams.industryId = industry.id;
    this.selectedParams.subCategory1Id = null;  // Reset SubCategory1 and SubCategory2
    this.selectedParams.subCategory2Id = null;
    this.getAllSubCategory(industry.id)

    // this.subCategoryProducts = [];
    // const find_category = this.categories.find((item) => item.industry_name === category.industry_name)
    // if (this.selectedCategory == category.industry_name || find_category.industry_name === category.industry_name) {
    //   this.selectedCategory = category.industry_name;
    //   this.industry = category;

    //   console.log('4444444444', this.industry.id);
    //   this.selectedFilter = 'All';

    //   this.getAllSubCategory(category.id, category.industry_name)

    // }


  }

  // Select Filter and reload products for the selected category
  selectFilter(filter: string) {
    this.selectedFilter = filter; // Update the filter
    this.applyFilter()

  }

  applyFilter() {
    switch (this.selectedFilter) {
      case 'Made in India':
        this.subCategoryProducts = this.allProducts.filter((product) => {

          return product.country_origin === 'India';
        });
        break;
      case 'Imported':
        this.subCategoryProducts = this.allProducts.filter(product => product.country_origin !== 'Imported');
        break;
      default:
        this.subCategoryProducts = this.allProducts;
        break;
    }
  }

  // // Method to handle "View All" click
  viewAll(subCategoryName: string, categoryName: string, dropdownMenu: HTMLElement) {
    const dropdownInstance = new bootstrap.Dropdown(dropdownMenu);
    dropdownInstance.hide();
    this.router.navigate([this.viewall], { queryParams: { subCategory: subCategoryName, category: categoryName } });
  }

  filterData2(searchTerm: any): Observable<string[]> {
    if (!searchTerm) {
      return of([]);
    }

    const searchTermString = String(searchTerm).toLowerCase();

    if (!this.Searchresults || !Array.isArray(this.Searchresults)) {
      console.error('Search results are not initialized or invalid.');
      return of([]);
    }

    // Filter results based on the search term
    let filteredResults2 = this.Searchresults.filter((item: any) => {
      const itemTitle = item?.Category3?.title || '';
      return itemTitle.toLowerCase().includes(searchTermString);
    });

    // Remove duplicates by creating a Set of unique titles
    const uniqueResults = Array.from(
      new Map(
        filteredResults2.map((item) => [item?.Category3?.title, item])
      ).values()
    );

    return of(uniqueResults);
  }


  // selectSubCategory(subCategoryID: string) {
  //   this.selectedFilter = 'All';
  //   const selectedSubCat = this.subCategoryData.find(subCat => subCat.id === subCategoryID);
  //   if (selectedSubCat) {
  //     this.selectedSubCategory = selectedSubCat.sub_category_name; // Set the selected subcategory name
  //   }
  //   const payload = {
  //     sortType: 'ASC',
  //     industry_id: this.industry.id,
  //     sub_category_id: subCategoryID,
  //   };
  //   this.service.get(payload, API_ROUTES.Marketplace.mymarketproductList).subscribe(
  //     (response) => {
  //       if (response.success && response.result) {
  //         let products = [];
  //         const machine = response?.result?.Machine || response?.result?.Services || response?.result?.Tools || response?.result?.['Raw Material']
  //         if (machine && machine.subcategories) {
  //           for (const [key, subcategory] of Object.entries(machine.subcategories)) {
  //             const subcategoryData = subcategory as {
  //               sub_category_id: string;
  //               products: any[];
  //             }
  //             if (subcategoryData.sub_category_id === subCategoryID) {
  //               products = subcategoryData.products.slice(0, 4) || [];
  //               break;
  //             }
  //           }
  //         }
  //         this.subCategoryProducts = products;
  //         this.allProducts = products;

  //       } else {
  //         console.error("Invalid response structure or no products found");
  //       }

  //     },
  //     (error) => {
  //       console.error('Error occurred while fetching industries:', error);
  //     }
  //   );

  // }

  filterDialog() {
    this.scrolledBottom = false;
    const dialogRef = this.dialog.open(FilterProductComponent, {
      maxHeight: "100vh",
      width: "421px",
      panelClass: "filter",
      data: {
        sortBy: this.sortby,
        filterBy: this.filterData,
        filterData: this.filterData,
      },
    });
    dialogRef.afterClosed().subscribe((data: { result: boolean; sortdata: any[]; filterdata: { [x: string]: any; }; }) => {
      if (data.result == true) {
        if (data.sortdata) {
          let sortFind = data.sortdata.find((el: any) => el.isSelected == true);
          if (sortFind) {
            this.sortby = sortFind.value;
          } else {
            this.sortby = null;
          }
        }
        if (data.filterdata) {
          Object.keys(data.filterdata).forEach((key) => {
            if (data.filterdata[key] == "" || data.filterdata[key] == "0") {
              delete data.filterdata[key];
              this.show = true;
            }
          });
          this.filterData = data.filterdata;
          //

          //
        }
        this.page = 1;
        this.Size = 20;
        this.data = [];

      }
    });
  }


  goBack() {
    this.commonService.goBack();
  }

  guestUserPopup() {
    // console.log("This");
    this.commonService.guestUserPopup();
  }

  myProfile() {
    if (this.guestUser) {
      this.commonService.guestUserPopup();
    } else {
      this.router.navigate([
        "/" +
        RouteConstant.main +
        "/" +
        RouteConstant.profile +
        "/" +
        RouteConstant.about,
      ]);
    }
  }


  dashboard() {
    if (this.guestUser) {
      this.commonService.guestUserPopup();
    } else {
      this.router.navigate([
        "/" +
        RouteConstant.main +
        "/" +
        RouteConstant.profile +
        "/" +
        RouteConstant.Dashboard,
      ]);
    }
  }


  MyListings() {
    if (this.guestUser) {
      this.commonService.guestUserPopup();
    } else {
      this.router.navigate([
        "/" +
        RouteConstant.main +
        "/" +
        RouteConstant.profile +
        "/" +
        RouteConstant.MyListings,
      ]);
    }
  }

  myRequirement() {
    if (this.guestUser) {
      this.commonService.guestUserPopup();
    } else {
      this.router.navigate([
        "/" +
        RouteConstant.main +
        "/" +
        RouteConstant.profile +
        "/" +
        RouteConstant.Requirements,
      ]);
    }
  }

  MyWishlist() {
    if (this.guestUser) {
      this.commonService.guestUserPopup();
    } else {
      this.router.navigate([
        "/" +
        RouteConstant.main +
        "/" +
        RouteConstant.profile +
        "/" +
        RouteConstant.MyWishlist,
      ]);
    }
  }

  Enquiries() {
    if (this.guestUser) {
      this.commonService.guestUserPopup();
    } else {
      this.router.navigate([
        "/" +
        RouteConstant.main +
        "/" +
        RouteConstant.profile +
        "/" +
        RouteConstant.Enquiry,
      ]);
    }
  }

  SettingsPreferences() {
    if (this.guestUser) {
      this.commonService.guestUserPopup();
    } else {
      this.router.navigate([
        "/" +
        RouteConstant.main +
        "/" +
        RouteConstant.profile +
        "/" +
        RouteConstant.moreSettings,
      ]);
    }
  }

  myMarketPlace() {
    if (this.guestUser) {
      this.commonService.guestUserPopup();
    } else {
      this.router.navigate([
        "/" + RouteConstant.main + "/" + RouteConstant.myMarketPlaceList,
      ]);
    }
  }

  notificationList() {
    if (this.guestUser) {
      this.commonService.guestUserPopup();
    } else {
      this.router.navigate([
        "/" +
        RouteConstant.main +
        "/" +
        RouteConstant.home +
        "/" +
        RouteConstant.notificationList,
      ]);
    }
  }



  businessTab() {
    this.commonService.businessTabPopup();

  }

  // Extract the parts for binding
  getNotificationTextParts(item: any) {
    const match = item.text.match(/^(.*)"(.*)"(.*)$/);
    if (match) {
      return {
        prefix: match[1],
        product: match[2],
        suffix: match[3],
        product_id: item.product_id
      };
    }

  return {
    prefix: item.text,
    product: '',
    suffix: '',
    product_id: item.product_id
  };
}

  viewSingleProduct(productId: string) {
  
        this.router.navigate([RouteConstant.productdetail], { queryParams: { productId: productId } });
 
    
  }


}
